import React from 'react';

import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

type CardFooterProps = {
  /** The text to display inside the button. */
  buttonLabel: string;

  /** The function to call when the button is clicked. */
  onClick: React.MouseEventHandler<HTMLButtonElement>;

  /** Whether the button should be disabled. Defaults to false. */
  isDisabled?: boolean;
};

/**
 * Renders a button inside a Bootstrap Card.Footer.
 */
const CardFooter = ({buttonLabel, onClick, isDisabled = false}: CardFooterProps) => {
  if (!buttonLabel || !onClick) return null;

  return (
    <Card.Footer>
      <Row className="justify-content-center">
        <Col md="6" lg="4" className="text-center d-grid">
          <Button size="lg" onClick={onClick} disabled={isDisabled}>
            {buttonLabel}
          </Button>
        </Col>
      </Row>
    </Card.Footer>
  );
}

export default CardFooter;